import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

export default function Footer() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const handleAdminAccess = () => {
    if (user) {
      navigate('/admin/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <footer className="bg-[#915726] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/c613884721c0b6590a025a9d6892fb89/457808a8ae48aaa1390aecf44d721494.png"
              alt="Plennittá"
              className="h-9 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/80 text-sm leading-relaxed">
              Instituto de excelência em emagrecimento e estética, dedicado a transformar vidas através de tratamentos personalizados.
            </p>
          </div>

          <div>
            <h4
              className="text-xl font-bold mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Navegação
            </h4>
            <ul className="space-y-3">
              {[
                { id: 'home', label: 'Home' },
                { id: 'antes-depois', label: 'Antes e Depois' },
                { id: 'servicos', label: 'Tratamentos Exclusivos' },
                { id: 'depoimentos', label: 'Histórias de Transformação' },
                { id: 'contato', label: 'Agende Sua Avaliação' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer hover:translate-x-1 inline-block"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  onClick={handleAdminAccess}
                  className="text-white/80 hover:text-white transition-colors text-sm cursor-pointer hover:translate-x-1 inline-block"
                >
                  Área Administrativa
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-xl font-bold mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Serviços
            </h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li>Emagrecimento Personalizado</li>
              <li>Tratamentos Faciais</li>
              <li>Modelagem Corporal</li>
              <li>Drenagem Linfática</li>
              <li>Depilação a Laser</li>
              <li>Tratamentos Capilares</li>
            </ul>
          </div>

          <div>
            <h4
              className="text-xl font-bold mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Contato
            </h4>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-0.5"></i>
                <span>JFC Trade Center — Sala 201<br />Av. Min. Geraldo Barreto Sobral, 2100<br />Jardins, Aracaju - SE</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-lg"></i>
                <span>(79) 99982-7205</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-lg"></i>
                <span>plennitta@gmail.com</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-lg"></i>
                <a
                  href="https://instagram.com/institutoplennitta"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  @institutoplennitta
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm text-center md:text-left">
            © 2025 Plennittá. Todos os direitos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/70 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
